module.exports = "<div class=\"editorUi-row\">\n  <div v-tabs:top=\"{ borderColor: '#31333b' }\" class=\"editorUi-tabs\">\n    <ul class=\"editorUi-tabsMenu\">\n      <li class=\"editorUi-tab editorUi-tab-bubble\">\n        <a class=\"editorUi-tabLink editorUi-tabLink-bubble\" href=\"#editorUi-tabContent-1\">Settings</a>\n      </li>\n    </ul>\n    <div class=\"editorUi-tabContent\">\n      <!-- Styling Tab -->\n      <div class=\"editorUi-tabContent-1\"></div>\n    </div>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/global-view/editor/droplets/divider/components/_edit-options/template.html
// module id = 5Phz
// module chunks = 0